import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { GatewayService } from '../../../../../../core/services/gateway.service';

@Component({
  selector: 'app-detach-gateway',
  templateUrl: './detach-gateway.component.html',
  styleUrls: ['./detach-gateway.component.scss']
})
export class DetachGatewayComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<DetachGatewayComponent>,
    private gatewayService: GatewayService,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA)
    public data: { titleMessage: string, bodyMessage: string, nodeName: string },
  ) { }
  ngOnInit(): void {
  }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit() {
    this.gatewayService.detachGatewayForVM(this.data.nodeName).subscribe({
      next: (data: any) => {
        this.snackBar.open("Gateway Is Detached", "Ok", { duration: 5000 });
        this.spinner.hide();
      }, error: (err: any) => {
        this.snackBar.open("Gateway Could Not be Detached " || "Action cannot be completed.", "Ok", { duration: 5000 });
        this.spinner.hide();
      }
    })
    this.dialog.close();
  }

}
